"use client";

import { useState, useEffect } from "react";
import { Quote } from "lucide-react";

const testimonials = [
  {
    quote:
      "I work in Azure every day and going through this course has not only increased my knowledge on Azure security hardening but I also got to be part of a Red Team. I definitely recommend anyone working in Azure Security check out CloudBreach.",
    name: "Matt Dibiaso",
    role: "Cloud Security Engineer",
    company: "2nd Watch",
    initials: "MD",
    handle: null,
    href: "https://www.linkedin.com/feed/update/urn:li:activity:6952295704069353472",
  },
  {
    quote:
      "For anyone starting out in Cloud Security or experienced in it; this course has something for everyone. I was impressed with the course structure and vast domain topics. For the price, 30 days of access to multiple Azure environments is excellent training.",
    name: "Eric Tomasello",
    role: "VP of Solution Architecture & Cyber Security",
    company: null,
    initials: "ET",
    handle: null,
    href: "https://www.linkedin.com/posts/eric-tomasello-2669803_im-happy-to-share-that-ive-obtained-a-new-activity-6981252796125716480-tV19?utm_source=share&utm_medium=member_desktop",
  },
  {
    quote:
      "The course was fully practical and lab-based covering Azure Resource Enumeration, Conditional Access Bypass, Illicit Consent Grant Attacks, Key Vault misconfigs, LogicApps, Storages, AKS misconfigs, JWT manipulation and more.",
    name: "Abisola Dayspring Johnson",
    role: "Cloud Detection Engineering",
    company: "Datadog",
    initials: "AD",
    handle: "@Daycyberwox",
    href: "https://twitter.com/daycyberwox/status/1542261741857431552",
  },
  {
    quote:
      "I had a great experience from the labs and materials for learning Azure Security Attacks. After completing my exam, I would recommend this to anyone willing to learn about Azure and AAD Attacks.",
    name: "Nikhil",
    role: "Security Analyst",
    company: null,
    initials: "N",
    handle: "@0xw0lf",
    href: "https://twitter.com/0xw0lf/status/1556283827676295168",
  },
  {
    quote:
      "The CloudBreach Breaching Azure course is a good introduction to common Azure and related cloud misconfigurations. The labs are well structured and the content is practical and relevant to real-world scenarios.",
    name: "Michael Smirnoff",
    role: "Cloud Incident Response Manager",
    company: "Commonwealth Bank",
    initials: "MS",
    handle: null,
    href: "https://cloudinfosec.net/oasp-review/",
  },
  {
    quote:
      "I've done quite a few config reviews for Azure environments, but this course absolutely blew my mind, in particular how far certain misconfigurations can be pushed. Highly recommended for any cloud pen tester.",
    name: "Ugnius G.",
    role: "Penetration Tester",
    company: "Bulletproof",
    initials: "UG",
    handle: null,
    href: "https://www.linkedin.com/feed/update/urn:li:activity:7026230382576451584",
  },
  {
    quote:
      "Successfully passed the Offensive Azure Security Professional (OASP) exam. The exam was pretty tough compared to the labs and required some out of the box thinking. Great course for anyone wanting to get into Azure offensive security.",
    name: "Jony Schats",
    role: "Senior Ethical Hacker and Security Officer",
    company: "HackDefense",
    initials: "JS",
    handle: null,
    href: "https://www.linkedin.com/feed/update/urn:li:activity:7041125429130260480",
  },
  {
    quote:
      "Excited to have passed the Offensive Azure Security Professional (OASP) Exam. The CloudBreach Team is amazing. The labs are well put together and really help you understand how to attack Azure environments.",
    name: "Vasilis Tasiopoulos",
    role: "Red Team Leader",
    company: "Neurosoft",
    initials: "VT",
    handle: null,
    href: "https://www.linkedin.com/posts/vasilis-tasiopoulos-1b8a7238_offensive-azure-security-professional-activity-6978240396757745665-vojt",
  },
  {
    quote:
      "Over the last month I had the opportunity to go through and complete the Breaching Azure Lab which replicates a complex enterprise environment with multiple Azure tenants. Excellent hands-on content.",
    name: "Khalid Elkawlak",
    role: "Security & Privacy Consultant",
    company: "Protiviti",
    initials: "KE",
    handle: null,
    href: "https://www.linkedin.com/feed/update/urn:li:activity:7004785210332442625",
  },
  {
    quote:
      "If you are looking for an intense 24-hour exam pattern with real-world cloud misconfiguration, you should definitely go for the OAWSP. The labs and exam are excellent for anyone in cloud offensive security.",
    name: "Dhiyaneshwaran",
    role: "AppSec Researcher",
    company: "pdiscovery.io",
    initials: "DG",
    handle: null,
    href: "https://dhiyaneshgeek.github.io/cloud/security/2024/02/26/oawsp-exam-review/",
  },
  {
    quote:
      "Earning this badge signifies a leap in my understanding of AWS security vulnerabilities and defense strategies. The course content is practical and the labs give you real hands-on experience attacking AWS environments.",
    name: "Dauntae S.",
    role: "Security Engineer",
    company: "DailyPay",
    initials: "DS",
    handle: null,
    href: "https://www.linkedin.com/posts/activity-7182987918691479552-x4yP?utm_source=share&utm_medium=member_desktop",
  },
  {
    quote:
      "Both the exam and the content were incredibly engaging and enjoyable. I learned numerous techniques for attacking AWS environments that I hadn't seen in other training resources.",
    name: "Manuel Perez",
    role: "AppSec Engineer",
    company: "Hackmetrix",
    initials: "MP",
    handle: null,
    href: "https://www.linkedin.com/posts/manuel-perez-069985245_offensive-aws-security-professional-activity-7178086943371485184-jGWp?utm_source=share",
  },
  {
    quote:
      "The content is valuable, up-to-date and presented in a realistic way. I often find that courses like this either over-simplify things or show them in ways that are not really applicable to the real world. It is definitely not the case here. Support response times via Discord are insanely fast, sometimes in a matter of seconds. For the price they charge it's a real bang for the buck.",
    name: "Kevin",
    role: "Breaching Azure & Azure Advanced",
    company: null,
    initials: "K",
    handle: null,
    href: "https://www.trustpilot.com/review/cloudbreach.io",
  },
  {
    quote:
      "What I liked most is the strong focus on real-world attack scenarios, you're not just watching content, you're actively exploiting misconfigurations across Azure and AWS environments. The certification exam approach is also well done, focusing on hands-on problem solving rather than theory, which reflects real engagement conditions.",
    name: "Escnr",
    role: "Breaching Azure & Breaching AWS",
    company: null,
    initials: "E",
    handle: null,
    href: "https://www.trustpilot.com/review/cloudbreach.io",
  },
  {
    quote:
      "CloudBreach manages to combine cutting edge red teaming techniques with proper technical backing. The labs are advanced and teach you valuable techniques you can apply during your pentesting and red teaming engagements. And the exams push you just that little bit further.",
    name: "Arthur Donkers",
    role: "Breaching Azure Advanced",
    company: null,
    initials: "AD",
    handle: null,
    href: "https://www.trustpilot.com/review/cloudbreach.io",
  },
];

const PER_PAGE = 4;
const TOTAL_PAGES = Math.ceil(testimonials.length / PER_PAGE);

function getSource(href: string): { label: string; color: string } {
  if (href.includes("linkedin.com")) return { label: "LinkedIn", color: "text-[#4C93E0]" };
  if (href.includes("twitter.com") || href.includes("x.com")) return { label: "X / Twitter", color: "text-cb-text" };
  if (href.includes("trustpilot.com")) return { label: "Trustpilot", color: "text-[#00b67a]" };
  return { label: "Article", color: "text-cb-violet-text" };
}

function StarRow() {
  return (
    <div className="flex gap-0.5" aria-label="5 stars">
      {Array.from({ length: 5 }).map((_, i) => (
        <svg key={i} width="16" height="16" viewBox="0 0 24 24" fill="#00b67a" xmlns="http://www.w3.org/2000/svg">
          <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
        </svg>
      ))}
    </div>
  );
}

function TpStar({ size = 16 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="white" xmlns="http://www.w3.org/2000/svg">
      <path d="M12 2l2.582 7.948H22.5l-6.708 4.874 2.582 7.948L12 18.051 5.626 22.77l2.582-7.948L1.5 9.948H9.418L12 2z" />
    </svg>
  );
}

function TrustpilotScore({ rating, reviewCount }: { rating: number; reviewCount: number }) {
  const fullStars = Math.round(rating);
  return (
    <a
      href="https://www.trustpilot.com/review/cloudbreach.io"
      target="_blank"
      rel="noopener noreferrer"
      className="group flex flex-col sm:flex-row items-center gap-5 transition-opacity hover:opacity-80"
    >
      <span className="sr-only">CloudBreach on Trustpilot:</span>
      <div className="flex gap-1.5">
        {Array.from({ length: 5 }).map((_, i) => (
          <div key={i} className="flex items-center justify-center" style={{ width: 48, height: 48, backgroundColor: i < fullStars ? "#00b67a" : "#dcdce6" }}>
            <TpStar size={30} />
          </div>
        ))}
      </div>
      <div className="flex items-baseline gap-2">
        <span className="text-5xl font-bold text-cb-text tabular-nums">{rating}</span>
        <div className="flex flex-col">
          <span className="text-xs font-semibold text-cb-muted uppercase tracking-widest">TrustScore</span>
          <span className="text-xs text-cb-muted-2">{reviewCount} reviews</span>
        </div>
      </div>
    </a>
  );
}

export function TestimonialBlock({ rating = 4.3, reviewCount = 7 }: { rating?: number; reviewCount?: number }) {
  const [page, setPage] = useState(0);
  const [fading, setFading] = useState(false);

  useEffect(() => {
    const id = setInterval(() => {
      setFading(true);
      setTimeout(() => {
        setPage((p) => (p + 1) % TOTAL_PAGES);
        setFading(false);
      }, 400);
    }, 45000);
    return () => clearInterval(id);
  }, []);

  const visible = testimonials.slice(page * PER_PAGE, (page + 1) * PER_PAGE);

  return (
    <section className="py-24 bg-cb-bg" id="reviews">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="flex items-end justify-between mb-14">
          <div>
            <p className="text-xs font-semibold text-cb-violet-text uppercase tracking-widest font-mono mb-3">
              From the community
            </p>
            <h2 className="text-3xl sm:text-4xl font-bold text-cb-text">
              What practitioners say.
            </h2>
          </div>
          {/* Page dots */}
          <div className="flex items-center gap-2 pb-1">
            {Array.from({ length: TOTAL_PAGES }).map((_, i) => (
              <button
                key={i}
                onClick={() => { setFading(true); setTimeout(() => { setPage(i); setFading(false); }, 400); }}
                aria-label={`Page ${i + 1}`}
                className="group/dot flex h-11 w-11 items-center justify-center cursor-pointer"
              >
                <span
                  className={`h-1.5 rounded-full transition-all duration-300 ${
                    i === page ? "w-6 bg-cb-violet" : "w-1.5 bg-cb-border group-hover/dot:bg-cb-muted-2"
                  }`}
                />
              </button>
            ))}
          </div>
        </div>

        {/* Review grid */}
        <div
          className="grid md:grid-cols-2 gap-6 mb-14 transition-opacity duration-400"
          style={{ opacity: fading ? 0 : 1 }}
        >
          {visible.map((t) => {
            const source = getSource(t.href);
            return (
              <a
                key={t.name}
                href={t.href}
                target="_blank"
                rel="noopener noreferrer"
                className="flex flex-col rounded-xl border border-cb-border bg-cb-surface p-6 hover:border-cb-violet/30 transition-colors cursor-pointer"
              >
                <div className="flex items-center justify-between mb-4">
                  <Quote className="h-5 w-5 text-cb-violet/40" />
                  <StarRow />
                </div>
                <p className="text-sm text-cb-muted leading-relaxed flex-1 mb-6">
                  &ldquo;{t.quote}&rdquo;
                </p>
                <div className="flex items-center justify-between pt-4 border-t border-cb-border">
                  <div className="flex items-center gap-3">
                    <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-cb-violet/10 border border-cb-violet/20 text-xs font-semibold text-cb-violet-text font-mono">
                      {t.initials}
                    </div>
                    <div>
                      <p className="text-sm font-medium text-cb-text">
                        {t.name}
                        {t.handle && (
                          <span className="ml-1.5 text-xs text-cb-muted font-mono">{t.handle}</span>
                        )}
                      </p>
                      <p className="text-xs text-cb-muted">
                        {t.role}{t.company && ` · ${t.company}`}
                      </p>
                    </div>
                  </div>
                  <span className={`text-xs font-medium ${source.color} shrink-0`}>
                    {source.label}
                  </span>
                </div>
              </a>
            );
          })}
        </div>

        {/* Trustpilot score */}
        <div className="flex justify-center pt-10 border-t border-cb-border">
          <TrustpilotScore rating={rating} reviewCount={reviewCount} />
        </div>
      </div>
    </section>
  );
}
